export default __webpack_public_path__ + "static/media/ordRightTriangle.0fdb5a54.svg";